import script from "./SelectionBasketPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectionBasketPanel.vue?vue&type=script&setup=true&lang=js"

import "./SelectionBasketPanel.vue?vue&type=style&index=0&id=386f3ac5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-386f3ac5"]])

export default __exports__